var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('row-action',{attrs:{"icon":"EyeIcon","label":_vm.label || _vm.$t('foundation.rowView'),"danger":false}})}
var staticRenderFns = []

export { render, staticRenderFns }